/** @type {import('tailwindcss').Config} */
const formkitTailwind = require('@formkit/themes/tailwindcss');

module.exports = {
  content: [
    "./index.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
    "./formkit.config.ts"
  ],
  theme: {
    extend: {
      colors: {
        'primary': '#101828',
        'tertiary': '#475467',
        'rl-primary': {
          50: '#f5f4fe',
          100: '#eeecfb',
          200: '#dedbf9',
          300: '#c6bef4',
          400: '#a998ed',
          500: '#8b6ee4',
          600: '#7f56d9', // base color
          700: '#6a3dc4',
          800: '#5933a4',
          900: '#4a2b87',
          950: '#2d1a5b',
        },
        "rl-base-pink": {
          50: "#fef1f8",
          100: "#fde6f3",
          200: "#fdcde9",
          300: "#fda5d6",
          400: "#fa6cb8",
          500: "#f4409b",
          600: "#e41e79",
          700: "#c6105e",
          800: "#a4104e",
          900: "#881344",
          950: "#540324",
        },
        "rl-base-blue": {
          50: "#edf4ff",
          100: "#deebff",
          200: "#c4d9ff",
          300: "#a0c0ff",
          400: "#7e9eff",
          500: "#5b77f9",
          600: "#3d4fee",
          700: "#2f3cd3",
          800: "#2935aa",
          900: "#293486",
          950: "#181c4e",
        },
        "rl-base-turquoise": {
          50: "#f0fdfa",
          100: "#cdfaf2",
          200: "#9af5e4",
          300: "#55e7d2",
          400: "#2fd2c0",
          500: "#16b6a7",
          600: "#0e9389",
          700: "#10756e",
          800: "#125d59",
          900: "#144d4a",
          950: "#042f2f",
        },
        "rl-base-purple": {
          50: '#ededff',
          100: '#dedfff',
          200: '#c4c4ff',
          300: '#a3a0ff',
          400: '#8777ff', // primary
          500: '#795bf9',
          600: '#6c3dee',
          700: '#5e2fd3',
          800: '#4c29aa',
          900: '#402986',
          950: '#27184e',
        },     
        'rl-linear-gradient':{
          "very-light-blue":"linear-gradient(237.14deg, rgba(112, 179, 255, 0.3) 5.34%, rgba(156, 128, 255, 0.3) 95.44%);"
        },
        "percentage-gradient": {
          0: "#FF86B1",
          5: "#ee89c0",
          10: "#dd8ccf",
          15: "#cf8edb",
          20: "#BA92EC",
          25: "#b093f2",
          30: "#a993f6",
          35: "#a194fb",
          40: "#9b94ff",
          45: "#8b9aff",
          50: "#7a9fff",
          55: "#6aa4ff",
          60: "#5fa8ff",
          65: "#5db6ff",
          70: "#5bc4ff",
          75: "#59d0ff",
          80: "#56e1ff",
          85: "#56e3f3",
          90: "#56e5e6",
          95: "#56e6dc",
          100: "#55E8CD",
        },
        'rl-base-opacity':{
          'white':"rgba(255, 255, 255, 0.2)",
        },
        'rl-form-error':{
          "transparent-pink": "rgba(255, 138, 173, 0.30)"
        }, 
        'light-grey':'#9598A3',
        'dark-grey':'#58595B',
        'sky-blue':"#80A0FE",
        'elements-bg':'#E9EDF4',
        'dark-blue': "#182230",
        'soft-purple': "#e7e3ff",
        'light-blue-gray': "#e7edfa",
      },
      fontFamily: {
        quicksand: ["Quicksand", "sans-serif"],
      },
      boxShadow: {
        journeys: "0px 8px 30px rgba(128, 140, 163, 0.15)",
        login: "0px 0px 40px rgba(89, 112, 223, 0.15)",
        admin: "0px 4px 10px 0px rgba(0, 0, 0, 0.20)",
        card: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        buttons: "0px 4px 10px 0px rgba(0, 0, 0, 0.15)",
        box: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
      },
      width: {
        "1/7": "14.28%",
      },
      borderRadius: {
        DEFAULT: "24px"
      }
    },
  },
  plugins: [
    formkitTailwind,
    require('@tailwindcss/forms'),
  ],
};
